import { render, staticRenderFns } from "./RingbaIntegrationOnboarding.vue?vue&type=template&id=df57fcbe&scoped=true"
import script from "./RingbaIntegrationOnboarding.vue?vue&type=script&lang=js"
export * from "./RingbaIntegrationOnboarding.vue?vue&type=script&lang=js"
import style0 from "./RingbaIntegrationOnboarding.vue?vue&type=style&index=0&id=df57fcbe&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "df57fcbe",
  null
  
)

export default component.exports